import React, { memo, useState } from 'react'; 
import { FaUserCircle,FaCommentDots, FaSearch } from "react-icons/fa";
import { BsBoxArrowRight } from "react-icons/bs";
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';

const Sidebar = ({ chats }) => {
  const location = useLocation(); 
  const [searchTerm, setSearchTerm] = useState("");


  
  const filteredChats = chats?.filter((chat) => {
    const name = (chat.profile_name ?? chat.wa_id).toLowerCase();
    return name.includes(searchTerm.toLowerCase());
  });

  return (
    <div className="sidebar">

      <div className="search-bar">
        <div className="search-input-wrapper">
          <FaSearch color="#54656f" />
          <input onChange={(e) => setSearchTerm(e.target.value)}  type="text" placeholder="Search chat" />
        </div>
      </div>

      <div className="chat-list">
        {filteredChats && filteredChats.map((chat) => {
          const isActive = location.pathname === `/chat/${chat.wa_id}`;

          return (
            <Link 
              to={`/chat/${chat.wa_id}`} 
              key={chat.id} 
              style={{ textDecoration: 'none' }}
            >
              <div className={`chat-item ${isActive ? 'active' : ''}`}>
                <FaUserCircle fontSize={35} color="#54656f" />
                <div className="chat-info">
                  <div className="chat-top">
                    <span className="chat-name">{chat.profile_name ?? chat.wa_id}</span>
                    <span className="chat-time">
                        {moment(chat.last_message_time).format('h:mm A')}
                    </span>
                  </div>
                  <div className="chat-preview" style={{display:'flex',justifyContent:'space-between'}}>
                    <span>
                      {chat.last_message.length > 60 ? chat.last_message.substring(0, 60) + "..." : chat.last_message}
                    </span>
                    {(chat?.is_read == 'N')&&
                      <span>
                        <FaCommentDots fontSize={20} color="#54656f" />
                      </span>
                    }
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default memo(Sidebar);